<template>
    <a-modal :visible="visible" :title="state.title" @cancel="handleModalCancel" width="70%" :destroy-on-close="true"
        :footer="null">

        <AForm ref="formRef" class="myform" :model="form" :rules="state.rules" @finish="handleOk"
            :wrapper-col="{ span: 14 }" :scroll-to-first-error="true">

            <!-- kode -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Kode" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }" required
                        name="code" has-feedback>
                        <a-input placeholder="Kode" width="100%" v-model:value="form.code" :disabled="form.readOnly" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- No Referensi - SAP / Shipto -->
            <ARow class="form-row">
                <ACol :sm="{ span: 24, offset: 8 }" :lg="{ span: 24, offset: 6 }" :xxl="{ span: 24, offset: 4 }">
                    <AForm class="myform-vertical" layout="vertical">
                        <template v-for="(item, index) in state.references.filter(i => !i.is_deleted)" :key="index">
                            <ARow class="form-row">
                                <ACol :sm="4">
                                    <AFormItem label="Kode Referensi" label-align="left" :name="['vendorCodes', 'code']"
                                        has-feedback>
                                        <AInput size="small" type="number" v-model:value="item.code"
                                            :disabled="form.readOnly || item.id" />
                                    </AFormItem>
                                </ACol>
                                <ACol :sm="4">
                                    <AFormItem label="Nama" label-align="left" has-feedback>
                                        <AInput size="small" v-model:value="item.name"
                                            :disabled="form.readOnly || item.id" />
                                    </AFormItem>
                                </ACol>

                                <ACol v-if="!form.readOnly" :sm="4">
                                    <AFormItem label=" " label-align="left">
                                        <AButton @click="removeRowReference(item)" size="small" type="danger">
                                            <i class="fa fa-remove" />
                                        </AButton>
                                    </AFormItem>
                                </ACol>
                            </ARow>
                        </template>
                    </AForm>
                    <!-- add referensi -->
                    <AFormItem v-if="!form.readOnly" label-align="left" :wrapper-col="{ sm: { span: 24 - 4 - 8 } }"
                        :colon="false">
                        <AButton type="primary" @click="AddReference">
                            <i class="fa fa-plus"></i> Tambah Kode Referensi
                        </AButton>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="No Referensi - SAP / Shipto" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }"
                        name="reference_number" has-feedback>
                        <a-input placeholder="No Referensi - SAP / Shipto" width="100%"
                            v-model:value="form.reference_number" :disabled="form.readOnly" />
                    </AFormItem>
                </ACol>
            </ARow> -->

            <!-- register_date -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Tanggal Registrasi" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }" required
                        name="register_date" has-feedback>
                        <ADatePicker v-model:value="form.register_date" style="width:100%" value-format="YYYY-MM-DD" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- nama -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Nama Project" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }" required
                        name="name" has-feedback>
                        <AInput placeholder="Nama Project" v-model:value="form.name" :disabled="form.readOnly" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- alamat -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Alamat" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }"
                        name="address" has-feedback>
                        <AInput placeholder="alamat" v-model:value="form.address" :disabled="form.readOnly" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- pilih kabupaten/kota -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Kabupaten/Kota" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }" required
                        name="wilayah_id" has-feedback>
                        <FilterWilayahSemua v-model:value="form.wilayah_id" :disabled="form.readOnly" />
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- distributor_id -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Distributor Derivative" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }" required
                        name="distributor_id" allow-clear>
                        <FilterDistributorDerivatives :type="1113" :multiple="false" show-search
                            v-model:value="form.distributor_id" :join-options="form.vendorRaw ? form.vendorRaw : []"
                            label="fullname" style="width: 100%" :disabled="form.readOnly"
                            v-model:items="distributorItems">
                        </FilterDistributorDerivatives>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- userid_kam -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="User KAM" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }"
                        name="userid_kam" allow-clear>
                        <FilterSales :multiple="false" size="small" :mode="null" type="text" class="mb-0 lh-1"
                            style="width: 100%" :role_id="salesDerivativesRoles.KAM" v-model:value="form.userid_kam"
                            :wilayah_id="form.wilayah_id" :disabled="form.readOnly || !form.wilayah_id">
                        </FilterSales>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- userid_sm -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="User SM" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }"
                        name="userid_sm" allow-clear>
                        <FilterSales :multiple="false" size="small" :mode="null" type="text" class="mb-0 lh-1"
                            style="width: 100%" :role_id="salesDerivativesRoles.SM" v-model:value="form.userid_sm"
                            :wilayah_id="form.wilayah_id" :disabled="form.readOnly || !form.wilayah_id">
                        </FilterSales>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- userid_gm -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="User GM" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }"
                        name="userid_gm" allow-clear>
                        <FilterSales :multiple="false" size="small" :mode="null" type="text" class="mb-0 lh-1"
                            style="width: 100%" :role_id="salesDerivativesRoles.GM" v-model:value="form.userid_gm"
                            :wilayah_id="form.wilayah_id" :disabled="form.readOnly || !form.wilayah_id">
                        </FilterSales>
                    </AFormItem>
                </ACol>
            </ARow>

            <!-- segment -->
            <ARow class="form-row">
                <ACol :sm="24">
                    <AFormItem label="Segment" label-align="left"
                        :label-col="{ sm: { span: 8 }, lg: { span: 6 }, xxl: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 8 }, lg: { span: 24 - 6 }, xxl: { span: 24 - 4 } }"
                        name="segment">
                        <ASelect v-model:value="form.segment" :options="segmentOptions" placeholder="Pilih Segment"
                            style="width:100%" />
                    </AFormItem>
                </ACol>
            </ARow>

            <ARow v-if="!form.readOnly" class="form-row" type="flex" justify="end">
                <ACol>
                    <AFormItem>
                        <a-button type="primary" html-type="submit" :loading="form.busy" :disabled="form.busy">{{
                            !form.id ? 'Simpan' : 'Perbarui'
                        }}</a-button>
                    </AFormItem>
                </ACol>
            </ARow>
        </AForm>

        <div v-if="form.errors.any()">
            <ASpace>
                <AAlert v-for="(item, index) in form.errors.all()" type="error" :key="index" :message="item.message"
                    banner closable @close="form.clear()" />
            </ASpace>
        </div>
    </a-modal>
</template>
<script>
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
    nextTick,
} from 'vue'
import Form from 'vform'
import apiClient from '@/services/axios'
import { Modal, Select, message } from 'ant-design-vue'
import includes from 'lodash/includes'
import FilterDistributorDerivatives from '@/components/filter/FilterDistributorDerivatives'
import FilterWilayahSemua from '@/components/filter/FilterWilayahSemua'
import FilterSales from '@/components/filter/FilterSales'

export default defineComponent({
    components: {
        FilterDistributorDerivatives,
        FilterSales,
        FilterWilayahSemua,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
                readOnly: false,
            }),
        },
    },
    emits: ['success', 'update:visible', 'update:item'],

    setup(props, { emit }) {
        const form = reactive(
            new Form({
                id: props.item.id,
                code: '',
                reference_number: '',
                register_date: null,
                name: '',
                address: '',
                wilayah_id: null,
                segment: null,
                distributor_id: null,
                userid_kam: null,
                userid_sm: null,
                userid_gm: null,
                type: 1, // default
            }),
        )

        const formRef = ref();
        const segmentOptions = ref([])
        const distributorItems = ref([])

        const state = reactive({
            title: 'Lihat Segment Project',
            endpoint: '/api/derivatives/projects',
            data: [],
            references: [],
            reference: {
                id: null,
                code: null,
                nama: '',
            },
            page: 1,
            per_page: 1,
            total: 0,
            loading: false,
            rules: {
                code: [
                    {
                        required: true,
                        message: 'Kode tidak boleh kosong',
                    },
                ],

                register_date: [
                    {
                        required: true,
                        message: 'Tanggal Registrasi tidak boleh kosong',
                    },
                ],

                wilayah_id: [
                    {
                        required: true,
                        message: 'Wilayah tidak boleh kosong',
                    },
                ],

                name: [
                    {
                        required: true,
                        message: 'Nama Project tidak boleh kosong',
                    },
                ],

                segment: [
                    {
                        required: true,
                        message: 'Segment wajib dipilih',
                    },
                ],

                distributor_id: [
                    {
                        required: true,
                        message: 'Distributor wajib dipilih',
                    },
                ],
            },
        })

        const salesDerivativesRoles = ref({})

        const fetchSalesRoles = async () => {
            const { data } = await apiClient.get('/api/filter/role-sales-derivatives')

            salesDerivativesRoles.value = data
        }

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const removeRowReference = (item) => {
            const index = state.references.indexOf(item)

            if (item.id === null) {
                state.references.splice(index, 1)
            } else {
                item.is_deleted = true
            }
        }

        const AddReference = () => {
            if (state.references.filter(v => v.code === null).length > 0) {
                message.warning('Pastikan kode referensi terisi!')
                return
            }

            state.references.push(Object.assign({}, state.reference))
        }

        const handleOk = async () => {
            form.type = 1;

            // validation form
            await formRef.value.validate()
                .catch(() => { });

            if (!form.id) {
                form.post(state.endpoint)
                    .then(({ data }) => {
                        const promises = []
                        state.references.forEach(c => {
                            c.vendor_id = data.id
                            const post = apiClient
                                .post(`${state.endpoint}/${data.id}/codes`, c)
                            promises.push(post)
                        })
                        Promise.all(promises).catch(() =>
                            message.warning('Gagal simpan kode referensi!, silakan cek data distributor.'),
                        )

                        message.success('Berhasil menyimpan')

                        handleModalCancel()
                        emit('success', data)
                    })
                    .catch(() => {
                        message.error('Gagal menyimpan data')
                    })
            } else {
                form.put(`${state.endpoint}/${form.id}`)
                    .then(({ data }) => {
                        const promises = []
                        state.references.filter(c => c.id === null)
                            .forEach(c => {
                                c.vendor_id = data.id
                                const post = apiClient
                                    .post(`${state.endpoint}/${data.id}/codes`, c)
                                promises.push(post)
                            })

                        state.references.filter(c => c.is_deleted)
                            .forEach(c => {
                                c.vendor_id = data.id
                                const _delete = apiClient
                                    .delete(`${state.endpoint}/${data.id}/codes/${c.id}`)
                                promises.push(_delete)
                            })

                        Promise.all(promises).catch(() =>
                            message.warning('Gagal simpan kode referensi!, silakan cek data distributor.'),
                        )

                        message.success('Berhasil memperbarui')

                        handleModalCancel()
                        emit('success', data)
                    })
                    .catch(() => {
                        message.error('Gagal menyimpan data')
                    })
            }

        }

        // fetch by id
        const fetchByID = (id) => {
            apiClient
                .get(`${state.endpoint}/${id}`)
                .then(async ({ data }) => {
                    form.code = data.code
                    form.reference_number = data.reference_number
                    form.register_date = data.register_date
                    form.name = data.name
                    form.address = data.address
                    form.wilayah_id = data.wilayah_id
                    form.segment = data.segment
                    form.distributor_id = data.distributor_id

                    await nextTick()

                    form.userid_kam = data.userid_kam
                    form.userid_sm = data.userid_sm
                    form.userid_gm = data.userid_gm
                    form.type = 1

                    apiClient
                        .get(`${state.endpoint}/${id}/codes`)
                        .then(({ data }) => {
                            state.references = Object.assign([], data.items)
                        })
                        .catch(error => console.error(error))
                })
                .catch(error => console.error({ failure: error }))
        }

        const fetchSegment = () => {
            apiClient
                .get('/api/filter/segment-projects?type=1')
                .then(({ data }) => {
                    segmentOptions.value = data.map(item => ({
                        value: item.id,
                        label: item.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                    segmentOptions.value = []
                })
        }

        // handle func vue
        onMounted(async () => {
            await fetchSalesRoles()

            fetchSegment()

            if (!form.id) {
                form.reset()
            } else {
                fetchByID(form.id)
            }

            form.readOnly = props.item.readOnly

            if (!props.item.readOnly) {
                state.title = `${!form.id ? 'Tambah' : 'Edit'} Project`
            }
        })

        return {
            formRef,
            handleOk,
            form,
            state,
            segmentOptions,
            distributorItems,
            handleModalCancel,
            removeRowReference,
            AddReference,
            salesDerivativesRoles,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
